import PropTypes from 'prop-types';

import { backgroundColors } from '~/theme';

export const AcfLink = PropTypes.shape({
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    target: PropTypes.string
});

export const AcfBackgroundColor = {
    backgroundColor: PropTypes.oneOf(Object.keys(backgroundColors))
};

export const GlobalBlockOptions = PropTypes.shape({
    marginBottom: PropTypes.oneOf([
        'none',
        'small',
        'medium',
        'section',
        'default'
    ])
});

export const DefaultGlobalBlockOptions = {
    marginBottom: 'default'
};

export const AcfAttributes = PropTypes.shape({
    className: PropTypes.string,
    anchor: PropTypes.string
});

export const DefaultAcfAttributes = {
    className: '',
    anchor: ''
};
